/**
 * Load blocks files.
 */
"use strict";

import './ticker/block';
import './banner/block';
import './post-grid/block';
import './post-list/block';
import './post-masonry/block';
import './post-tiles/block';
import './post-carousel/block';
import './post-slider/block';
import './post-block/block';
import './post-filter/block';
import './category-collection/block';
import './timeline/block';